import React, { useState, useEffect } from "react";
import './Admin.css';
import LoggerDataService from "../../services/logger.service";

  class AdminLog extends React.Component{

    constructor(props) {
      super(props);
      const isLoggedIn = window.localStorage.getItem("userid") ? true : false;
      let userid = 0;
    
      if(isLoggedIn)
      {
      userid = window.localStorage.getItem("userid");
  
      }
      this.state = {
        list: []
  
      };
    }

    componentDidMount() {

      LoggerDataService.getAll()
      .then(res => {
          if(res.data != '')
          {
            res.data.map(res1 => {

              var data = {
                id: res1.userid,
                message: res1.message,
                category:  res1.category
               
            }


            this.setState({
              list: [
              ...this.state.list,
               data
              ]
            }); 

            })

          }
         
          
      })
    }

    render(){
      return (
    <div className="row col-md-12">
        {
            this.state.list != []  && this.state.list.length > 0?
            <div>
            <table responsive className="table">
            <thead>
              <tr>
                <td>Message</td>
                <td>Category</td>
                <td>User Id</td>
                <td></td>
                </tr>
            </thead>
            <tbody>
            {
            this.state.list.map((log,index) => (
                        <tr key="table_logs" >
                        <td key={index + "_a"} className="table-text-color">{log.message}</td>  
                        <td key={index + "_b"} className="table-text-color">{log.category}</td>  
                        <td key={index + "_c"} className="table-text-color">{log.id}</td>  
                       
                      </tr>
                                   
                    ))
            }
            </tbody>
            </table>
            </div>
         
          : <span className="table-text-color">No Log Messages found</span>

        }
    </div>
    
      )
      }
}



export default AdminLog;